export default "__VITE_ASSET__T08Dbo9q__"